import { ListOfUserPermissionResponse } from './Api/ListOfUserPermissionResponse';

export class UserPermissionEntity extends ListOfUserPermissionResponse {
	public static tryCast(o: any): UserPermissionEntity {
		const ret = new UserPermissionEntity();
		return Object.assign(ret, o);
	}
}
